/* Djurslottet - relevanta KOLLEKTIONER langst ner i header-sokets dropdown.

   FYRA FALLGROPAR, alla uppmatta i webblasaren 2026-08-12 (pa tema 9, portat hit):

   1) INLINE <script> I EN HEADER-GROUP-SEKTION KORS ALDRIG. Skriptet lag i DOM:en med
      4791 tecken och parsade utan fel, men ingen lyssnare kopplades. Gruppen injiceras via
      innerHTML/section-hydration, och innerHTML-inlagda skript exekverar inte.
      -> all JS ligger i den har externa asseten.

   2) SOKET BYGGER OM .dj-hsearch__content VID VARJE TRAFF. Ett block INUTI content revs
      bort ~250 ms senare (matt: cols=true vid 250 ms, false fran 500 ms). MutationObserver
      pa panelen raddade inte heller - noden byts ut.
      -> blocket laggs i .dj-hsearch__panel EFTER content + en vakthund var 300 ms.

   3) ANTAL PRODUKTER FINNS INTE i /search/suggest.json (faltet returneras aldrig).
      -> sektionen skickar med en handle -> antal-karta i [data-dj-cols-config].

   4) CHATTBUBBLAN <shopify-chat> lag over forslagen pa mobil. Appen satter egna inline-
      stilar, sa vanlig CSS forlorar -> vi satter inline med !important och tar bort igen.

   Scrollen ligger pa panelen - se kommentaren i sections/dj-search-collections.liquid.
   Timing: soket har egen debounce, sa panelen ar inte oppen nar input-eventet kommer.
   Darfor provar attempt() upp till 12 ganger med 160 ms mellanrum. */
(function () {
  window.__djCols = 'loaded';

  var DEF = {
    heading: 'Kollektioner', chip: 'Kollektion', limit: 3,
    showCount: true, hideChat: true, one: 'produkt', many: 'produkter', counts: {}
  };
  var CFG = null;
  var cache = {};
  var shownFor = '';

  function cfg() {
    if (CFG) return CFG;
    CFG = {
      heading: DEF.heading, chip: DEF.chip, limit: DEF.limit,
      showCount: DEF.showCount, hideChat: DEF.hideChat,
      one: DEF.one, many: DEF.many, counts: DEF.counts
    };
    var el = document.querySelector('[data-dj-cols-config]');
    if (el) {
      try {
        var j = JSON.parse(el.textContent || '{}');
        if (j.heading) CFG.heading = j.heading;
        if (j.chip) CFG.chip = j.chip;
        if (j.limit) CFG.limit = parseInt(j.limit, 10) || DEF.limit;
        if (typeof j.showCount === 'boolean') CFG.showCount = j.showCount;
        if (typeof j.hideChat === 'boolean') CFG.hideChat = j.hideChat;
        if (j.one) CFG.one = j.one;
        if (j.many) CFG.many = j.many;
        if (j.counts) CFG.counts = j.counts;
      } catch (e) {}
    }
    return CFG;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m];
    });
  }

  function imgUrl(o) {
    var u = (o.featured_image && (o.featured_image.url || o.featured_image)) || o.image || '';
    if (typeof u !== 'string' || !u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?|$)/i, '_80x$1$2');
  }

  function handleOf(col) {
    if (col.handle) return col.handle;
    var m = String(col.url || '').match(/\/collections\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  function suggest(q) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=collection&resources[limit]=' + cfg().limit;
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var r = j && j.resources && j.resources.results;
        return (r && r.collections) || [];
      })
      .catch(function () { return []; });
  }

  /* Ger hela fragan noll traffar, prova forsta ordet: "hundsele for valp" -> "hundsele" */
  function lookup(q) {
    if (cache[q]) return Promise.resolve(cache[q]);
    return suggest(q).then(function (list) {
      if (list.length) return list;
      var first = q.trim().split(/\s+/)[0];
      if (first && first.length > 2 && first !== q.trim()) return suggest(first);
      return [];
    }).then(function (list) { cache[q] = list; return list; });
  }

  function drop() {
    var old = document.querySelector('.dj-hs-cols');
    if (old) old.remove();
    shownFor = '';
  }

  function chipText(col) {
    var C = cfg();
    var n = C.counts[handleOf(col)];
    if (!C.showCount || !n) return C.chip;
    return C.chip + ' · ' + n + ' ' + (n === 1 ? C.one : C.many);
  }

  function render(q, list) {
    var old = document.querySelector('.dj-hs-cols');
    if (old) old.remove();

    var panel = document.querySelector('.dj-hsearch__panel');
    var content = panel && panel.querySelector('.dj-hsearch__content');
    if (!panel || !content || !list.length) { shownFor = ''; return false; }

    var C = cfg();
    var html = '<div class="dj-hs-cols__h">' +
      '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M10 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-8l-2-2z"/></svg>' +
      esc(C.heading) + '</div>';

    for (var i = 0; i < list.length; i++) {
      var col = list[i];
      var src = imgUrl(col);
      html += '<a class="dj-hs-col" href="' + esc(col.url) + '">' +
        (src
          ? '<img class="dj-hs-col__img" src="' + esc(src) + '" alt="" loading="lazy" width="34" height="34">'
          : '<span class="dj-hs-col__img"></span>') +
        '<span class="dj-hs-col__t">' + esc(col.title) + '</span>' +
        '<span class="dj-hs-col__chip">' + esc(chipText(col)) + '</span>' +
        '<svg class="dj-hs-col__go" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>' +
      '</a>';
    }

    var box = document.createElement('div');
    box.className = 'dj-hs-cols';
    box.innerHTML = html;
    /* EFTER content, inte inuti - content byggs om vid varje traff */
    content.insertAdjacentElement('afterend', box);
    shownFor = q;
    return true;
  }

  function term() {
    var i = document.querySelector('.dj-hsearch__input');
    return i ? i.value.trim() : '';
  }
  function isOpen() {
    var p = document.querySelector('.dj-hsearch__panel');
    return !!(p && p.classList.contains('is-open'));
  }
  function ready() {
    return isOpen() && !!document.querySelector('.dj-hs-body');
  }

  function chat(hide) {
    if (!cfg().hideChat) return;
    document.documentElement.classList.toggle('dj-search-open', !!hide);
    var els = document.querySelectorAll('shopify-chat, inbox-online-store-chat');
    for (var i = 0; i < els.length; i++) {
      if (hide) {
        els[i].style.setProperty('opacity', '0', 'important');
        els[i].style.setProperty('pointer-events', 'none', 'important');
      } else {
        els[i].style.removeProperty('opacity');
        els[i].style.removeProperty('pointer-events');
      }
    }
  }

  function attempt(q, tries) {
    if (term() !== q) return;
    if (!ready()) {
      if (tries > 0) setTimeout(function () { attempt(q, tries - 1); }, 160);
      return;
    }
    lookup(q).then(function (list) {
      if (term() !== q) return;
      render(q, list);
    });
  }

  var t = null;
  function schedule() {
    clearTimeout(t);
    t = setTimeout(function () {
      var q = term();
      if (q.length < 2) { drop(); return; }
      attempt(q, 12);
    }, 200);
  }

  function isInput(el) {
    return el && el.classList && el.classList.contains('dj-hsearch__input');
  }
  document.addEventListener('input', function (e) { if (isInput(e.target)) schedule(); }, true);
  document.addEventListener('focusin', function (e) { if (isInput(e.target)) schedule(); }, true);

  /* Vakthund: soket river blocket nar det bygger om sig, och panelnoden kan bytas ut
     (sa en MutationObserver dor). Nagra billiga querySelector var 300 ms racker. */
  var wasOpen = false;
  setInterval(function () {
    var open = isOpen();
    if (open !== wasOpen) { wasOpen = open; chat(open); }

    var q = term();
    if (!open || q.length < 2) {
      if (document.querySelector('.dj-hs-cols')) drop();
      return;
    }
    if (!document.querySelector('.dj-hs-cols') || shownFor !== q) attempt(q, 2);
  }, 300);
})();
